import {type SelectedSilos} from '@domain/schedule'
import {dataTestId} from '@hconnect/uikit'
import {SilosIcon} from '@hconnect/uikit/src/common'
import {Typography, Skeleton, Stack} from '@mui/material'
import moment from 'moment-timezone'
import {FC} from 'react'

import {useHistoryStoragesByIdQuery} from '../../../hooks'
import {PlannerIcon} from '../../PlannerIcon'
import {usePlanningChartStartEnd} from '../../providers'

import {SelectedSilo} from './SelectedSilo'

interface SelectedSilosRow {
  selectedSilos: SelectedSilos
  scheduleItemEnd: string
}

export const SelectedSilosRow: FC<SelectedSilosRow> = ({selectedSilos, scheduleItemEnd}) => {
  const {startOfPlan, endOfPlan} = usePlanningChartStartEnd()
  const scheduleItemEndUTC = moment.utc(scheduleItemEnd)
  const {data: storagesById} = useHistoryStoragesByIdQuery({
    timeFrame: [startOfPlan, endOfPlan],
    date: scheduleItemEndUTC
  })
  return (
    <Stack direction="row" spacing={0} alignItems="center" {...dataTestId('selected_silos_row')}>
      <PlannerIcon icon={<SilosIcon />} sx={{pl: 0}} />
      <Stack direction="row" alignItems="center" flexWrap="wrap" gap={2}>
        {storagesById ? (
          <SelectedSilo selectedSilos={selectedSilos} storagesById={storagesById} />
        ) : (
          <Typography variant="body1">
            <Skeleton sx={{width: ({spacing}) => spacing(5)}} />
          </Typography>
        )}
      </Stack>
    </Stack>
  )
}
